import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Grid,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';
import ContentLoader from 'react-content-loader';

import styles from './styles';

const getGridItem = (classes) => (
  <Grid
    item
    xs={12}
    sm={6}
    md={4}
    lg={3}
    xl={2}
  >
    <Card classes={{ root: classes.card }}>
      <CardHeader
        classes={{
          root: classes.cardHeader,
          avatar: classes.avatar,
        }}
        title={(
          <ContentLoader height={120}>
            <circle rx="0" ry="0" cx="30" cy="30" r="30" height="60" />
            <rect x="100" y="0" rx="5" ry="5" width="220" height="20" />
            <rect x="100" y="30" rx="5" ry="5" width="150" height="20" />
          </ContentLoader>
        )}
      />
      <CardContent
        classes={{ root: classes.cardContent }}
      >
        <ContentLoader height={100} width={250}>
          <rect x="0" y="0" rx="3" ry="3" width="150" height="10" />
          <rect x="0" y="20" rx="3" ry="3" width="220" height="10" />

          <rect x="0" y="40" rx="3" ry="3" width="70" height="10" />
          <rect x="0" y="60" rx="3" ry="3" width="90" height="10" />
        </ContentLoader>
        <ContentLoader height={100} width={250}>
          <rect x="0" y="0" rx="3" ry="3" width="150" height="10" />
          <rect x="0" y="20" rx="3" ry="3" width="220" height="10" />

          <rect x="0" y="40" rx="3" ry="3" width="70" height="10" />
          <rect x="0" y="60" rx="3" ry="3" width="90" height="10" />
        </ContentLoader>
      </CardContent>
    </Card>
  </Grid>
);

class EventGridContentLoaderComponent extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <Grid container spacing={3}>
        {getGridItem(classes)}
        {getGridItem(classes)}
        {getGridItem(classes)}
        {getGridItem(classes)}
        {getGridItem(classes)}
      </Grid>
    );
  }
}

EventGridContentLoaderComponent.propTypes = { classes: PropTypes.object };

EventGridContentLoaderComponent.defaultProps = { classes: {} };

export default withStyles(styles)(EventGridContentLoaderComponent);
